import React, { FunctionComponent, ReactNode } from 'react';
import { useCheckUserGroupsAccess } from '../../hooks/useCheckUserGroupsAccess';
import UnauthorisedScreen from './UnauthorisedScreen/UnauthorisedScreen';
import { UserGroup } from '@round/api';

type ProtectedRouteProps = {
    children: ReactNode;
    groups: UserGroup[];
    hasAccessWhenMatches: 'all' | 'any';
};

const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = ({ children, groups, hasAccessWhenMatches = 'all' }) => {
    const canAccess = useCheckUserGroupsAccess(['trnds_product', ...groups], hasAccessWhenMatches);
    if (typeof canAccess !== 'boolean') {
        return null;
    }

    if (!canAccess) {
        return <UnauthorisedScreen />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
